// Vanilla JS Module Index

// common modules, included on every page
// using standard ES6 imports here because no codesplitting intended
import "./modules/navigation";
import "./modules/header";
import "./modules/cookieconsent";
import "./modules/conversion";
import "./modules/lazyloading";
import "./modules/instantpage";
import "./modules/lite-youtube";
import "./modules/darkmode";
import "./modules/eastereggs";
import "./modules/tabs";
import "./modules/details";

// JS Hooks have to be '.js-' prefixed classes/ids
const MODULES = [
  {
    selector: ".js-banner",
    importModule: () => import("./modules/banner.js"),
  },
  {
    selector: ".js-textfield",
    importModule: () => import("./modules/textfield.js"),
  },
  {
    selector: ".js-faq",
    importModule: () => import("./modules/faq.js"),
  },
  {
    selector: ".js-signup",
    importModule: () => import("./modules/signup.js"),
  },
  {
    selector: ".js-swiper",
    importModule: () => import("./modules/swiper.js"),
  },
  {
    selector: ".js-parallax",
    importModule: () => import("./modules/parallax.js"),
  },
  {
    selector: ".js-testimonials",
    importModule: () => import("./modules/testimonials.js"),
  },
  {
    selector: ".js-reaction-pill",
    importModule: () => import("./modules/reactionPill.js"),
  },
  {
    selector: ".js-copy-to-clipboard",
    importModule: () => import("./modules/copyToClipboard.js"),
  },
];
// Conditionally Import Modules based on DOM Nodes
const noop = () => {};
MODULES.forEach(({ selector, importModule }) => {
  if (document.querySelector(selector)) {
    importModule().then(noop);
  }
});
